import React from 'react';

import InlineCode from '~/components/InlineCode.react';
import SectionCode from '~/components/SectionCode.react';
import SectionDescription from '~/components/SectionDescription.react';
import SectionExample from '~/components/SectionExample.react';
import SectionTitle from '~/components/SectionTitle.react';

import PopoverSmall from '~/pages/components/popovers/PopoverSmall.react';
import PopoverMedium from '~/pages/components/popovers/PopoverMedium.react';
import PopoverLarge from '~/pages/components/popovers/PopoverLarge.react';

import { popoverSizes } from '~/components/CodeSnippets.js';

export default function PopoverSizes() {
    return (
        <section className="marginBottom-xl">
            <div className="marginBottom-m breakPointM-marginBottom-l">
                <SectionTitle sectionTitle={"Popover sizes"} />

                <SectionDescription>
                    There are three popover sizes: small, medium and large. Those
                    don't apply inner padding, but instead change caret size,
                    border radius and distance between the element and the popover.
                    They also adjust its default width (which can be overriden
                    with inline style). Apply <InlineCode>.popover--s</InlineCode>,{" "}
                    <InlineCode>.popover--m</InlineCode> and {" "}
                    <InlineCode>.popover--l</InlineCode> accordingly.
                </SectionDescription>
            </div>

            <SectionExample>
                <div className="grid grid--1 breakPointM-grid--3">
                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderRightWidth-1 breakPointL-borderBottomWidth-0">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverSmall />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Small popover</p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointL-borderBottomWidth-0 breakPointL-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverMedium />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Medium popover</p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderBottomWidth-0 breakPointM-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverLarge />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Large popover</p>
                    </div>
                </div>
            </SectionExample>

            <SectionCode codeType="language-html" code={popoverSizes} />
        </section>
    );
}



/** WEBPACK FOOTER **
 ** ./src/site/js/pages/components/popovers/PopoverSizes.react.js
 **/